export default "__VITE_ASSET__DcHIgKFT__"